<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-data-table
            v-model:options="options"
            dense
            :headers="headers"
            :loading="loading"
            :items="items"
            class="elevation-1"
            @update:options="updateTable"
          >
            <template #top>
              <v-card-title>
                <v-toolbar flat>
                  <v-toolbar-title>EFT Documents</v-toolbar-title>

                  <v-spacer />

                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search By Display Id, Document Name, Title"
                    single-line
                    hide-details
                    @input="searchTable()"
                  />

                  <v-spacer />

                  <!--  -->
                </v-toolbar>
              </v-card-title>
            </template>

            <template #item.display_id="{ item }">
              {{ item.display_id }}
            </template>

            <template #item.created_at="{ item }">
              {{ item.created_at ? formatDate(item.created_at) : '-' }}
            </template>

            <template #item.actions="{ item }">
              <v-btn
                tile
                color="primary"
                small
                text
                @click="showJsonModal('Document Data', item)"
              >
                <v-icon
                  dark
                  left
                  class="mr-1"
                >
                  mdi-eye
                </v-icon>
                Data
              </v-btn>

              <v-btn
                tile
                color="primary"
                small
                text
                @click="downloadPDF(item)"
              >
                <v-icon
                  dark
                  left
                  class="mr-1"
                >
                  mdi-download
                </v-icon>
                PDF
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <JsonModal
        v-model="jsonModal"
        :title="jsonTitle"
        :json="json"
        @close-modal="closeJsonModal()"
        @click:outside="closeJsonModal()"
      />
    </v-row>
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import { mapActions } from 'vuex';
import dataTableMixin from '@/mixins/dataTableMixin.js';
import JsonModal from '@/components/JsonModal.vue';

export default {
  name: 'EFTDocuments',
  components: {
    JsonModal,
  },
  mixins: [
    dataTableMixin,
  ],
  props: {
    customer: {
      type: Object,
      required: true,
    },
    customerLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { title: 'Loan Display Id', key: 'display_id' },
        { title: 'Account Type', key: 'account_type' },
        { title: 'Title', key: 'bank_account_title' },
        { title: 'File Name', key: 'file_name' },
        { title: 'Created Date', key: 'created_at' },
        { title: 'Actions', key: 'actions' },
      ],
      json: {},
      jsonTitle: '',
      jsonModal: false,
    };
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    async updateTable() {
      this.loading = true;

      const response = await this.$axios
        .get(`api/v1/loanpro-customer/${this.$route.params.customer_id}/eft-documents`, {
          params: {
            search: this.search,
          },
        });

      this.items = response.data;
      this.loading = false;
    },
    formatDate(date) {
      return DateTime.fromISO(date).toUTC().toLocaleString(DateTime.DATE_MED);
    },
    formatAmount(number) {
      const amount = parseFloat(number).toFixed(2);

      if (amount === '0.00') {
        return '-';
      }

      if (amount < 0) {
        return `-$${Math.abs(amount)}`;
      }

      return `$${amount}`;
    },
    closeJsonModal() {
      this.jsonModal = false;
      this.$nextTick(() => {
        this.json = {};
      });
    },
    showJsonModal(title, json) {
      this.json = json.fill_data;
      this.jsonTitle = title;
      this.jsonModal = true;
    },
    downloadPDF(doc) {
      this.$axios
        .get(
          `api/v1/loanpro-customer/${this.$route.params.customer_id}/eft-documents/${doc.id}/download-pdf`,
          { responseType: 'blob' },
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = doc.file_name;
          link.click();
          link.remove();

          this.setNotification({
            message: 'Statement pdf downloaded',
            color: 'green',
          });
        })
        .catch(async (error) => {
          const responseObj = await error.response.data.text();

          const jsonResponse = JSON.parse(responseObj);
          this.setNotification({
            message: `PDF could not be retrieved. If error persist please contact Dev Department. Details: ${jsonResponse.error}`,
            color: 'red',
          });
        });
    },
  },
};
</script>
